/** Cartes visuelles PRIO / STATUS / RACI — valeurs du design Todo DECO.dc.html. */

export const PRIO = {
  urgent: { label: "Urgent", color: "#E03E3E", bg: "#FBEAEA" },
  high: { label: "Haute", color: "#D9730D", bg: "#FBEEE1" },
  medium: { label: "Moyenne", color: "#B78619", bg: "#FAF3E2" },
  low: { label: "Basse", color: "#787774", bg: "#F1F0EE" },
} as const;
export type Priority = keyof typeof PRIO;

export const STATUS = {
  todo: { label: "À faire", dot: "#C7C6C2" },
  in_progress: { label: "En cours", dot: "#2F6FD6" },
  blocked: { label: "Bloquée", dot: "#E03E3E" },
  done: { label: "Terminée", dot: "#4C9A5B" },
  cancelled: { label: "Annulée", dot: "#9B9A97" },
  archived: { label: "Archivée", dot: "#9B9A97" },
} as const;
export type Status = keyof typeof STATUS;

/** RACI léger TM — 5 rôles (DT §4.1, policies tasks_task.yaml). */
export const ROLE = {
  driver: { label: "Driver", color: "#2f6fd6", bg: "#eaf1fd" },
  contributor: { label: "Contributor", color: "#4c9a5b", bg: "#eaf6ee" },
  approver: { label: "Approver", color: "#b7860f", bg: "#faf3e2" },
  consulted: { label: "Consulted", color: "#8e6fb8", bg: "#f2edf9" },
  informed: { label: "Informed", color: "#787774", bg: "#f1f0ee" },
} as const;
export type RaciRole = keyof typeof ROLE;

export const ACL_LEVELS = ["read", "comment", "write", "admin"] as const;
export type AclLevel = (typeof ACL_LEVELS)[number];

/** Couleur d'avatar déterministe (palette du design). */
const AVATAR_COLORS = [
  "#2f6fd6",
  "#4c9a5b",
  "#b7860f",
  "#8e6fb8",
  "#e03e3e",
  "#5b7bb5",
  "#d9730d",
];
export function avatarColor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length]!;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}
